import { MessageRole, WiseOwlApiIngress } from "../types";

export const mockTwilioSyncAccessToken =
  "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiIsImN0eSI6InR3aWxpby1mcGE7dj0xIn0.eyJqdGkiOiJTS3h4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4LTE0NTA0NzExNDciLCJpc3MiOiJTS3h4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4Iiwic3ViIjoiQUN4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eCIsIm5iZiI6MTQ1MDQ3MTE0NywiZXhwIjoxNDUwNDc0NzQ3LCJncmFudHMiOnsiaWRlbnRpdHkiOiJ1c2VyQGV4YW1wbGUuY29tIiwiaXBfbWVzc2FnaW5nIjp7InNlcnZpY2Vfc2lkIjoiSVN4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eCIsImVuZHBvaW50X2lkIjoiSGlwRmxvd1NsYWNrRG9ja1JDOnVzZXJAZXhhbXBsZS5jb206c29tZWlvc2RldmljZSJ9fX0.IHx8KeH1acIfwnd8EIin3QBGPbfnF-yVnSFp5NpQJi0";
export const mockTwilioSyncDocumentSid = "ETXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX";

export const mockGetChatHeaders = {
  "x-twilio-csrf": "csrf",
};

export const mockCreateUpdateHeaders = {
  ...mockGetChatHeaders,
  "Content-Type": "application/json",
};

export const mockZendeskCreateUpdateBody = {
  input: "I think you are way cool, Wise Owl, but from Zendesk",
};

export const mockOscCreateUpdateBody = {
  input: "I think you are way cool, Wise Owl",
  stream: true,
  recaptchaToken: "token",
};

export const mockOscUngatedCreateUpdateBody = {
  ...mockOscCreateUpdateBody,
  stargateUngatedUserId: "b441d9ac-65b8-4af3-aa1f-04d75104e0fe",
};

export const mockOscChat = {
  id: 189,
  createdAt: "2024-03-04T20:37:26.255Z",
  updatedAt: "2024-03-04T20:37:26.255Z",
  userId: "US046e8c33ddaa77748de95b406cc454cc",
  title: "Wow, way super nice. Best AI assistant ever.",
  ingress: "ONE_SUPPORT_CENTER",
  slackThreadTimestamp: null,
  slackConversationId: null,
  messages: [
    {
      id: 542,
      createdAt: "2024-03-04T20:37:35.847Z",
      updatedAt: "2024-03-04T20:37:35.847Z",
      chatId: 189,
      messageRole: "USER",
      content: "Wow, way super nice. Best AI assistant ever.",
      userId: null,
      slackMessageTimestamp: null,
      isComplete: null,
      toolCalls: [],
    },
    {
      id: 543,
      createdAt: "2024-03-04T20:37:35.847Z",
      updatedAt: "2024-03-04T20:37:35.847Z",
      chatId: 189,
      messageRole: "ASSISTANT",
      content:
        "Thank you so much for your kind words! I'm here to make sure you get the support and guidance you need. 😊 Is there anything specific you would like assistance with? Or are you encountering any issues we can help you with today?",
      userId: null,
      slackMessageTimestamp: null,
      isComplete: null,
      toolCalls: [
        {
          id: 48,
          createdAt: "2024-03-04T20:37:35.847Z",
          updatedAt: "2024-03-04T20:37:35.847Z",
          messageId: 543,
          name: "classifyCustomerIntent",
          input:
            '{\n    "transcript": "[user]\\n\\tWow, way super nice. Best AI assistant ever."\n}',
          output:
            '{"intent":"NONE","explanation":"The user\'s message is a compliment and does not contain any request for support or a specific query that could be classified into one of the given intents.","followUpQuestions":["Is there anything specific you would like assistance with?","Are you encountering any issues we can help you with today?"]}',
          formattedOutput:
            '{"intent":"NONE","explanation":"The user\'s message is a compliment and does not contain any request for support or a specific query that could be classified into one of the given intents.","followUpQuestions":["Is there anything specific you would like assistance with?","Are you encountering any issues we can help you with today?"]}',
        },
      ],
    },
  ],
};

export const mockOneAdminChat = {
  createdAt: "2023-11-02T22:02:53.627Z",
  id: "1c40bb13-e680-43b3-8d61-da9e17ca9e75",
  ingress: WiseOwlApiIngress.OneAdmin,
  messages: [
    {
      chatId: "1c40bb13-e680-43b3-8d61-da9e17ca9e75",
      content: "Hello wise owl",
      createdAt: "2023-11-02T22:02:54.517Z",
      id: "40a48d7a-357e-4d23-a661-142396a96c52",
      messageRole: MessageRole.User,
      isComplete: null,
      slackMessageTimestamp: null,
      updatedAt: "2023-11-02T22:02:54.517Z",
      userId: "nobody",
      toolCalls: [],
    },
    {
      chatId: "1c40bb13-e680-43b3-8d61-da9e17ca9e75",
      content: "Hello! How can I assist you with Twilio today?",
      createdAt: "2023-11-02T22:02:54.517Z",
      id: "40a48d7a-357e-4d23-a661-142396a96c53",
      messageRole: MessageRole.Assistant,
      isComplete: true,
      slackMessageTimestamp: null,
      updatedAt: "2023-11-02T22:02:54.517Z",
      userId: "AI",
      toolCalls: [],
    },
    {
      chatId: "1c40bb13-e680-43b3-8d61-da9e17ca9e75",
      content: "What is error code 30034?",
      createdAt: "2023-11-02T22:03:14.275Z",
      id: "40a48d7a-357e-4d23-a661-142396a96c54",
      messageRole: MessageRole.User,
      isComplete: null,
      slackMessageTimestamp: null,
      updatedAt: "2023-11-02T22:03:14.275Z",
      userId: "nobody",
      toolCalls: [],
    },
    {
      chatId: "1c40bb13-e680-43b3-8d61-da9e17ca9e75",
      content:
        "This error occurs when messages sent to US numbers are not delivered.",
      createdAt: "2023-11-02T22:03:14.275Z",
      id: "40a48d7a-357e-4d23-a661-142396a96c56",
      messageRole: MessageRole.Assistant,
      isComplete: true,
      slackMessageTimestamp: null,
      updatedAt: "2023-11-02T22:03:14.275Z",
      userId: "AI",
      toolCalls: [],
    },
  ],
  slackConversationId: null,
  slackThreadTimestamp: null,
  title: "Hello wise owl",
  updatedAt: "2023-11-02T22:02:53.627Z",
  userId: "nobody",
};

export const mockChatHistoryData = [
  {
    createdAt: "2023-12-13T16:10:16.578Z",
    id: "1c40bb13-e680-43b3-8d61-da9e17ca9e75",
    ingress: WiseOwlApiIngress.OneAdmin,
    slackConversationId: null,
    slackThreadTimestamp: null,
    title: "Hi Wise Owl. Could you tell me highlights from Twilio's",
    updatedAt: "2023-12-13T16:10:16.578Z",
    userId: "UScd4704062a7aff5ad051a07e93b427ce",
  },
  {
    createdAt: "2023-12-13T16:11:46.679Z",
    id: "1c40bb13-e680-43b3-8d61-da9e17ca9e76",
    ingress: WiseOwlApiIngress.OneAdmin,
    slackConversationId: null,
    slackThreadTimestamp: null,
    title: "Could you tell me more about what COMM-1934 is all",
    updatedAt: "2023-12-13T16:11:46.679Z",
    userId: "UScd4704062a7aff5ad051a07e93b427ce",
  },
  {
    createdAt: "2023-12-13T20:53:56.819Z",
    id: "1c40bb13-e680-43b3-8d61-da9e17ca9e77",
    ingress: WiseOwlApiIngress.OneAdmin,
    slackConversationId: null,
    slackThreadTimestamp: null,
    title: "Based on what, do fraudsters attack a country? Why/how",
    updatedAt: "2023-12-13T20:53:56.819Z",
    userId: "UScd4704062a7aff5ad051a07e93b427ce",
  },
];

export const mockWiseOwlGetChatByIdResponse = {
  success: true,
  data: mockOscChat,
};

export const mockWiseOwlGetChatByUserResponse = {
  success: true,
  data: {
    chats: [mockOscChat],
  },
};

export const mockWiseOwlCreateChatStreamResponse = {
  success: true,
  data: {
    accessToken: mockTwilioSyncAccessToken,
    syncDocumentSid: mockTwilioSyncDocumentSid,
    chatId: "32798537-32589235-325235",
  },
};

export const mockWiseOwlCreateChatResponse = {
  success: true,
  data: {
    chat: {
      id: 14,
      createdAt: "2024-03-01T23:43:29.358Z",
      updatedAt: "2024-03-01T23:43:29.358Z",
      userId: "US25a902fd18538662e9e9f36c62eb367e",
      title: "I think you are way cool, Wise Owl",
      ingress: "ONE_SUPPORT_CENTER",
      slackThreadTimestamp: null,
      slackConversationId: null,
      messages: [
        {
          id: 25,
          createdAt: "2024-03-01T23:43:41.773Z",
          updatedAt: "2024-03-01T23:43:41.773Z",
          chatId: 14,
          messageRole: "USER",
          content: "I think you are way cool, Wise Owl",
          userId: null,
          slackMessageTimestamp: null,
          isComplete: null,
          toolCalls: [],
        },
        {
          id: 26,
          createdAt: "2024-03-01T23:43:41.773Z",
          updatedAt: "2024-03-01T23:43:41.773Z",
          chatId: 14,
          messageRole: "ASSISTANT",
          content:
            "Thank you so much! I'm here to help you with any Twilio-related questions or guidance you might need. If there's anything specific you'd like to know or discuss, feel free to let me know. I'm all ears (or feathers, in my case)!",
          userId: null,
          slackMessageTimestamp: null,
          isComplete: null,
          toolCalls: [
            {
              id: 10,
              createdAt: "2024-03-01T23:43:41.773Z",
              updatedAt: "2024-03-01T23:43:41.773Z",
              messageId: 26,
              name: "classifyCustomerIntent",
              input:
                '{\n    "transcript": "[user]\\n\\tI think you are way cool, Wise Owl"\n}',
              output:
                '{"intent":"NONE","explanation":"The content provided does not pertain to any specific support issue or query related to Twilio\'s products or services, hence no intent from the provided categories can be identified.","followUpQuestions":["Could you please provide more details about the issue you\'re facing or the question you have regarding Twilio\'s services?"]}',
              formattedOutput:
                '{"intent":"NONE","explanation":"The content provided does not pertain to any specific support issue or query related to Twilio\'s products or services, hence no intent from the provided categories can be identified.","followUpQuestions":["Could you please provide more details about the issue you\'re facing or the question you have regarding Twilio\'s services?"]}',
            },
          ],
        },
      ],
    },
    blocks: [
      {
        type: "tool-call",
        display: "persistent",
        values: {
          name: "classifyCustomerIntent",
          input:
            '{\n    "transcript": "[user]\\n\\tI think you are way cool, Wise Owl"\n}',
          output:
            '{"intent":"NONE","explanation":"The content provided does not pertain to any specific support issue or query related to Twilio\'s products or services, hence no intent from the provided categories can be identified.","followUpQuestions":["Could you please provide more details about the issue you\'re facing or the question you have regarding Twilio\'s services?"]}',
          formattedOutput:
            '{"intent":"NONE","explanation":"The content provided does not pertain to any specific support issue or query related to Twilio\'s products or services, hence no intent from the provided categories can be identified.","followUpQuestions":["Could you please provide more details about the issue you\'re facing or the question you have regarding Twilio\'s services?"]}',
        },
      },
      {
        type: "message",
        display: "persistent",
        values: {
          role: "assistant",
          message:
            "Thank you so much! I'm here to help you with any Twilio-related questions or guidance you might need. If there's anything specific you'd like to know or discuss, feel free to let me know. I'm all ears (or feathers, in my case)!",
        },
      },
    ],
  },
};

export const mockWiseOwlUpdateChatStreamResponse = {
  success: true,
  data: {
    accessToken: mockTwilioSyncAccessToken,
    syncDocumentSid: mockTwilioSyncDocumentSid,
  },
};

export const mockWiseOwlUpdateChatResponse = {
  success: true,
  data: {
    chat: {
      id: 14,
      createdAt: "2024-03-01T23:43:29.358Z",
      updatedAt: "2024-03-01T23:43:29.358Z",
      userId: "US25a902fd18538662e9e9f36c62eb367e",
      title: "I think you are way cool, Wise Owl",
      ingress: "ONE_SUPPORT_CENTER",
      slackThreadTimestamp: null,
      slackConversationId: null,
      messages: [
        {
          id: 25,
          createdAt: "2024-03-01T23:43:41.773Z",
          updatedAt: "2024-03-01T23:43:41.773Z",
          chatId: 14,
          messageRole: "USER",
          content: "I think you are way cool, Wise Owl",
          userId: null,
          slackMessageTimestamp: null,
          isComplete: null,
          toolCalls: [],
        },
        {
          id: 26,
          createdAt: "2024-03-01T23:43:41.773Z",
          updatedAt: "2024-03-01T23:43:41.773Z",
          chatId: 14,
          messageRole: "ASSISTANT",
          content:
            "Thank you so much! I'm here to help you with any Twilio-related questions or guidance you might need. If there's anything specific you'd like to know or discuss, feel free to let me know. I'm all ears (or feathers, in my case)!",
          userId: null,
          slackMessageTimestamp: null,
          isComplete: null,
          toolCalls: [
            {
              id: 10,
              createdAt: "2024-03-01T23:43:41.773Z",
              updatedAt: "2024-03-01T23:43:41.773Z",
              messageId: 26,
              name: "classifyCustomerIntent",
              input:
                '{\n    "transcript": "[user]\\n\\tI think you are way cool, Wise Owl"\n}',
              output:
                '{"intent":"NONE","explanation":"The content provided does not pertain to any specific support issue or query related to Twilio\'s products or services, hence no intent from the provided categories can be identified.","followUpQuestions":["Could you please provide more details about the issue you\'re facing or the question you have regarding Twilio\'s services?"]}',
              formattedOutput:
                '{"intent":"NONE","explanation":"The content provided does not pertain to any specific support issue or query related to Twilio\'s products or services, hence no intent from the provided categories can be identified.","followUpQuestions":["Could you please provide more details about the issue you\'re facing or the question you have regarding Twilio\'s services?"]}',
            },
          ],
        },
        {
          id: 27,
          createdAt: "2024-03-01T23:48:04.554Z",
          updatedAt: "2024-03-01T23:48:04.554Z",
          chatId: 14,
          messageRole: "USER",
          content: "Wow, way super nice. Best AI assistant ever.",
          userId: null,
          slackMessageTimestamp: null,
          isComplete: null,
          toolCalls: [],
        },
        {
          id: 28,
          createdAt: "2024-03-01T23:48:04.554Z",
          updatedAt: "2024-03-01T23:48:04.554Z",
          chatId: 14,
          messageRole: "ASSISTANT",
          content:
            "I'm truly flattered by your kind words! It's my top priority to provide you with the best support and assistance. If there's anything Twilio-related you're curious about or need help with, just give a hoot. I'm here to make your experience as smooth and enjoyable as possible.",
          userId: null,
          slackMessageTimestamp: null,
          isComplete: null,
          toolCalls: [
            {
              id: 11,
              createdAt: "2024-03-01T23:48:04.554Z",
              updatedAt: "2024-03-01T23:48:04.554Z",
              messageId: 28,
              name: "classifyCustomerIntent",
              input:
                "{\n    \"transcript\": \"[user]\\n\\tI think you are way cool, Wise Owl\\n=====\\n[assistant]\\n\\tThank you so much! I'm here to help you with any Twilio-related questions or guidance you might need. If there's anything specific you'd like to know or discuss, feel free to let me know. I'm all ears (or feathers, in my case)!\\n=====\\n[user]\\n\\tWow, way super nice. Best AI assistant ever.\"\n}",
              output:
                '{"intent":"NONE","explanation":"The customer\'s messages are expressions of gratitude and positive feedback towards the assistant, and do not pertain to any support-related issues or inquiries that match the predefined categories.","followUpQuestions":["Is there a specific Twilio-related issue or question you need help with?"]}',
              formattedOutput:
                '{"intent":"NONE","explanation":"The customer\'s messages are expressions of gratitude and positive feedback towards the assistant, and do not pertain to any support-related issues or inquiries that match the predefined categories.","followUpQuestions":["Is there a specific Twilio-related issue or question you need help with?"]}',
            },
          ],
        },
      ],
    },
    blocks: [
      {
        type: "tool-call",
        display: "persistent",
        values: {
          name: "classifyCustomerIntent",
          input:
            "{\n    \"transcript\": \"[user]\\n\\tI think you are way cool, Wise Owl\\n=====\\n[assistant]\\n\\tThank you so much! I'm here to help you with any Twilio-related questions or guidance you might need. If there's anything specific you'd like to know or discuss, feel free to let me know. I'm all ears (or feathers, in my case)!\\n=====\\n[user]\\n\\tWow, way super nice. Best AI assistant ever.\"\n}",
          output:
            '{"intent":"NONE","explanation":"The customer\'s messages are expressions of gratitude and positive feedback towards the assistant, and do not pertain to any support-related issues or inquiries that match the predefined categories.","followUpQuestions":["Is there a specific Twilio-related issue or question you need help with?"]}',
          formattedOutput:
            '{"intent":"NONE","explanation":"The customer\'s messages are expressions of gratitude and positive feedback towards the assistant, and do not pertain to any support-related issues or inquiries that match the predefined categories.","followUpQuestions":["Is there a specific Twilio-related issue or question you need help with?"]}',
        },
      },
      {
        type: "message",
        display: "persistent",
        values: {
          role: "assistant",
          message:
            "I'm truly flattered by your kind words! It's my top priority to provide you with the best support and assistance. If there's anything Twilio-related you're curious about or need help with, just give a hoot. I'm here to make your experience as smooth and enjoyable as possible.",
        },
      },
    ],
  },
};
